import { Component, Story, Knobs } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  path: {
    default: 'https://countries.trevorblades.com/',
    editor: 'textbox',
  },
  query: {
    default: `{
  countries {
    code,
    name,
    phone,
    currency,
    continent {
      name
    }
  }
}`,
    editor: 'multilinetextbox',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A tag-graphql where you can change all the attributes',
  coreComponent: {
    html: `<tag-graphql{{...knobs}}>
  <tag-list
    primary-field="name"
    secondary-field="code"
    left-field-1="continentName"
    right-field-1="phone"
    right-field-2="currency"
    height="300px">
  </tag-list>
</tag-http>`,
    js: `var tagGraphQL = document.querySelector('tag-graphql');
tagGraphQL.componentOnReady().then(function() {
  tagGraphQL.responseMapper = function(response, request) {
    return {
      body: response.body.data.countries.map(function(country) {
        return {
          name: country.name,
          code: country.code,
          continentName: country.continent.name,
          phone: country.phone,
          currency: country.currency,
        };
      }),
    };
  };
});`,
    knobs: PlaygroundKnobs,
  },
};

export const TagGraphqlDocs: Component = {
  type: 'component',
  name: 'graphql',
  description: 'Makes a request to a graphQL server',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'requestEvents',
      description:
        'Determines when the http request is made. The request is made when the component loads by default. The available events are load, responseMapperAttached, search, pageRequest, click, refresh. This prop can take a comma delimited list of event names where multiple events should trigger the request',
      type: 'load | responseMapperAttached | headersAdded | search | pageRequest | click | refresh',
      default: 'load',
    },
    {
      name: 'path',
      description: 'The endpoint path of the GraphQL server',
      type: 'string',
    },
    {
      name: 'displayError',
      default: 'false',
      description: 'Whether any error messages are output',
      type: 'boolean',
    },
    {
      name: 'requestMapper',
      description: 'The function to call to map the request to the GraphQL request object',
      type: '(request: IGraphQLRequest) => IGraphQLRequest',
    },
    {
      name: 'responseMapper',
      description:
        'The function to call to map the data and paging info after it has been returned from the http request',
      type: '(response: IHttpResponse) => IHttpResponse',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'responded',
      description: 'Raised on a response',
      parameters: [
        {
          name: 'headers',
          description: 'The HTTP headers',
          type: 'Headers',
        },
        {
          name: 'status',
          description: 'The HTTP status code',
          type: 'number',
        },
        {
          name: 'ok',
          description: 'Whether the request was successful',
          type: 'boolean',
        },
        {
          name: 'body',
          description: 'The HTTP body',
          type: 'any',
        },
      ],
    },
  ],
  methods: [
    {
      name: 'setRequestHeader',
      description: 'Adds or sets and existing request HTTP header value',
      parameters: [
        {
          name: 'name',
          description: 'The HTTP header name',
          type: 'string',
        },
        {
          name: 'value',
          description: 'The HTTP header value',
          type: 'string',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'setRequestHeaders',
      description: 'Adds a collection of request HTTP headers',
      parameters: [
        {
          name: 'headers',
          description: 'Object literal containing the headers to set',
          type: '{ [key: string]: string }',
        },
      ],
      returnType: 'void',
    },
  ],
  stories: [PlaygroundStory],
};
